// extracted by mini-css-extract-plugin
export var breadcrumb = "_15-2";
export var breadcrumbArrow = "_15-3";
export var breadcrumbs = "_15-0";
export var link = "_15-4";
export var small = "_15-1";